/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
/**
 * @file 移动端导航栏组件
 * @author yuanyaojia@baijia.com
 * @date 2021-07-02
 */

import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import Iconfont from '~/component/Iconfont';

import './index.less';

const menuMobile = [
    {
        title: 'Home',
        path: '/home',
    },
    {
        title: 'Governance',
        path: 'governance',
        subRoutes: [
            {
                title: 'Corporate Profile',
                path: '/governance/corporate',
            },
            {
                title: 'Board of Directors',
                path: '/governance/board',

            },
            {
                title: 'Governance Documents',
                path: '/governance/documents',
            },

        ]
    },
    {
        title: 'News&Events',
        path: 'news',
        subRoutes: [
            {
                title: 'News Releases',
                path: '/news/releases',

            },
            {
                title: 'Events',
                path: '/news/events',

            },
            {
                title: 'AGM/EGM',
                path: '/news/agm',

            },
            {
                title: 'Videos',
                path: '/news/video',
            },
        ]
    },
    {
        title: 'Stock Infomation',
        path: 'stock',
        subRoutes: [
            {
                title: 'Stock Quote & Chart',
                path: '/stock/chart',
            },
            {
                title: 'Analyst Coverage',
                path: '/stock/analyst',
            },

        ],
    },
    {
        title: 'Financial Infomation',
        path: 'financial',
        subRoutes: [
            {
                title: 'Quarterly Results',
                path: '/financial/quarterly',
            },
            {
                title: 'Annual Reports',
                path: '/financial/annual',
            },
            {
                title: 'SEC Filings',
                path: '/financial/sec',
            },

        ]
    },
    {
        title: 'Contact Us',
        path: 'contact',
        subRoutes: [
            {
                title: 'IR Contacts',
                path: '/contact/ir',
            },
            {
                title: 'Investor Alerts',
                path: '/contact/investor',
            },
            {
                title: 'Investor FAQ',
                path: '/contact/faq',
            },
        ],
    },
];

function HeaderMoblie() {
    const history = useHistory();
    const {pathname, search} = window.location;
    const isDetail = pathname.includes('detail');
    const isUnsubscribe = pathname.includes('unsubscribe');
    const isNews = search.includes('news');
    const [show, setShow] = useState(false);
    const [expand, setExpand] = useState<any>({});

    function handleBack() {
        if (isDetail) {
            if (isNews) {
                history.push('/news/releases');
            }
            else {
                history.push('/news/events');
            }
        }
        if (isUnsubscribe) {
            history.push('/contact/investor');
        }
    }

    function hideMenu() {
        setShow(false);
        document.removeEventListener('click', () => {
            hideMenu();
        });
    }

    function showMenu(e) {
        // 阻止冒泡
        e.nativeEvent.stopImmediatePropagation();
        setShow(true);
        // 点击其他地方隐藏输入框
        document.addEventListener('click', () => {
            hideMenu();
        });
    }

    function handleClick(e) {
        // 阻止冒泡
        e.nativeEvent.stopImmediatePropagation();
    }


    function initExpand() {
        const expand = {
            'Governance': false,
            'News&Events': false,
            'Stock Infomation': false,
            'Financial Infomation': false,
            'Contact Us': false,
        };
        return expand;
    }

    function handleExpand(e) {
        const {title} = e.currentTarget.dataset;
        const isExpand = initExpand();
        isExpand[title] = !expand[title];
        setExpand(isExpand);
    }

    return (
        <>
            {
                isDetail || isUnsubscribe
                    ? (
                        <div
                            className="header-menu-m-back"
                            role="button"
                            tabIndex={0}
                            onClick={handleBack}
                        >
                            <Iconfont type="iconxiala" className="iconxiala-menu-back" />
                        </div>
                    )
                    : (
                        <>
                            <div className="header-menu-m">
                                <div className="header-menu-icon">
                                    <a href="/home">
                                        <img
                                            src="//i.gsxcdn.com/1609093770_ya9cb9ql.svg"
                                            alt="icon"
                                            className="header-icon-m"
                                        />
                                    </a>
                                    <div role="button" onClick={show ? hideMenu : showMenu}>
                                        {
                                            show
                                                ? (
                                                    <Iconfont type="iconguanbi-M" className="iconguanbi-m" />
                                                )
                                                : (
                                                    <Iconfont type="iconcaidan-M" className="iconcaidan-m" />
                                                )
                                        }
                                    </div>

                                </div>

                                <div
                                    className="header-menu-area"
                                    role="button"
                                    onClick={handleClick}
                                    tabIndex={0}
                                >
                                    {
                                        show
                                            && (
                                                <div className="header-submenu-content">
                                                    {
                                                        menuMobile.map(item => (
                                                            <div key={item.title}>
                                                                <div className="header-menu-title">
                                                                    {
                                                                        item.subRoutes
                                                                            ? (
                                                                                <>
                                                                                    <div
                                                                                        className="header-menu-inline"
                                                                                        role="button"
                                                                                        onClick={handleExpand}
                                                                                        tabIndex={0}
                                                                                        data-title={item.title}
                                                                                    >
                                                                                        {item.title}
                                                                                        <div>
                                                                                            <Iconfont
                                                                                                type="iconxiala"
                                                                                                className={
                                                                                                    expand[item.title]
                                                                                                        ? 'iconxiala-menu-mobile'
                                                                                                        : 'iconxiala-menu'
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </>

                                                                            )
                                                                            : (
                                                                                <a href={item.path}>
                                                                                    <div>
                                                                                        {item.title}
                                                                                    </div>
                                                                                </a>
                                                                            )
                                                                    }
                                                                </div>
                                                                {
                                                                    expand[item.title] && (
                                                                        <div className="header-submenu-container">
                                                                            {
                                                                                item.subRoutes?.map(subMenu => (
                                                                                    <a
                                                                                        href={subMenu.path}
                                                                                        key={subMenu.title}
                                                                                    >
                                                                                        <div
                                                                                            className="header-submenu-title"
                                                                                        >
                                                                                            {subMenu.title}
                                                                                        </div>
                                                                                    </a>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            )
                                    }
                                </div>
                            </div>
                        </>
                    )
            }
        </>
    );
}

export default HeaderMoblie;
